import type * as React from 'react'
import { Field } from '@/components/ui/Field'
import { Select, type SelectOption } from '@/components/ui/Select'
import type { FieldBinding } from './types'

interface SelectFieldProps<T extends object> extends FieldBinding<T> {
  options: readonly SelectOption<string>[]
  label?: React.ReactNode
  hint?: React.ReactNode
  required?: boolean
  placeholder?: string
  className?: string
}

export function SelectField<T extends object>({
  form,
  name,
  options,
  label,
  hint,
  required,
  placeholder,
  className,
}: SelectFieldProps<T>) {
  const error = form.errors[name]

  return (
    <Field label={label} hint={hint} error={error} required={required} htmlFor={name} className={className}>
      <Select
        id={name}
        options={options}
        value={String(form.data[name] ?? '')}
        onValueChange={(next) => form.setData(name, next as T[keyof T & string])}
        placeholder={placeholder}
        aria-invalid={!!error}
        triggerClassName="w-full"
      />
    </Field>
  )
}
